import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"

export const orderOptions = [
  { label: "Newest", value: "desc" },
  { label: "Oldest", value: "asc" },
]

export const statusOptions = [
  { label: "Failed", value: "failed" },
  { label: "Pending", value: "pending" },
  { label: "Confirmed", value: "confirmed" },
]

export const transactionsTopupFilter = [
  {
    ...getFilterSimpleFiled("address").search({
      col: 6,
      label: "Address",
      placeholder: "Search by address",
    }),
  },
  {
    ...getFilterSimpleFiled("id").search({
      col: 6,
      label: "ID",
      placeholder: "Search by ID",
    }),
  },
  {
    ...getFilterSimpleFiled("topupId").search({
      col: 6,
      label: "Topup ID",
      placeholder: "Search by Topup ID",
    }),
  },
  {
    ...getFilterSimpleFiled("txId").search({
      col: 6,
      label: "Tx ID",
      placeholder: "Search by Tx ID",
    }),
  },
  { ...filtersPresets.order, col: 6 },
  { ...filtersPresets.status, col: 6 },
  {
    ...getFilterSimpleFiled("amlLevel").select(
      [
        { label: "High", value: "high" },
        { label: "Medium", value: "medium" },
        { label: "Low", value: "low" },
      ],
      {
        col: 6,
        label: "AML level",
        placeholder: "Select AML level",
      },
    ),
  },
]
